import React from "react";
import moment from "moment";
import { Tooltip } from "@plum-xoxo/admin-dsm";
import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";
import IconButton from "../../components/styled/IconButton";
import styled from "styled-components";

const StyledDivGap = styled.div.attrs()`
  gap: 22px;
`;

const StyledDiv = styled.div`
  width: 42%;
`;

const StyledDiv30 = styled.div`
  width: 30%;
`;

const TODAY_DATE = moment().format("DD-MM-YYYY");
const RecepientDataComponent = (props) => {
  const {
    recipient,
    handleDeleteUserClick,
    handleEditUserData,
    currencyCode = "INR",
    addMore,
    isEditUserEnabled,
    rewardType,
    selectedSite,
    sendMode,
  } = props;

  return (
    <div className="mt-24 d-flex justify-content-between align-items-center w-100 px-24">
      {rewardType === 4 ? (
        <>
          <StyledDiv>
            <Typography className="m-0" color="dark" shade="c300">
              {recipient?.email?.length > 20
                ? `${recipient?.email?.slice(0, 20)}...`
                : recipient?.email}
            </Typography>
            {recipient.to_phone_number && (
              <Typography.HelperText className="m-0" color="dark" shade="c300">
                {recipient.to_phone_code.phonecode} {recipient.to_phone_number}
              </Typography.HelperText>
            )}
          </StyledDiv>
          <StyledDiv>
            <Typography className="m-0" color="dark" shade="c300">
              {rewardType !== 4 ? recipient.name : recipient.receiver_name}
            </Typography>
            <Typography.HelperText className="m-0" color="dark" shade="c300">
              {recipient?.country.label}
            </Typography.HelperText>
          </StyledDiv>
          <StyledDiv30>
            <Typography className="m-0" color="dark" shade="c300">
              {recipient?.voucherDetail?.currency_code}{" "}
              {recipient.denomination?.value.toLocaleString()}
            </Typography>
            <Typography.HelperText className="m-0" color="dark" shade="c300">
              {recipient?.voucherDetail?.currency_code}{" "}
              {recipient.denomination?.value.toLocaleString()} x{" "}
              {recipient.quantity}
            </Typography.HelperText>
          </StyledDiv30>
        </>
      ) : (
        <>
          <StyledDiv>
            <Typography
              color={"dark"}
              shade="c300"
              className="mb-0 text-break mr-8"
            >
              {recipient.name}
            </Typography>
            <Typography.HelperText color={"dark"} shade="c200" className="mb-0">
              {sendMode?.includes("email") && recipient?.email
                ? `${recipient.email}`
                : ""}
              {sendMode?.includes("email") &&
              (sendMode?.includes("sms") ||
                (sendMode?.includes("whatsapp") &&
                  recipient.to_phone_number !== ""))
                ? ", "
                : ""}
              {(sendMode?.includes("sms") || sendMode?.includes("whatsapp")) &&
              recipient.to_phone_number !== ""
                ? `${recipient.to_phone_code?.phonecode} ${recipient.to_phone_number}`
                : null}
            </Typography.HelperText>
            {(rewardType === 1 || rewardType === 2) &&
              recipient.date !== TODAY_DATE && (
                <Typography.HelperText>
                  Scheduled for{" "}
                  {moment(recipient.date, "DD-MM-YYYY").format("MMM D, YYYY")}
                </Typography.HelperText>
              )}
          </StyledDiv>
          <StyledDiv>
            <div>
              {
                <Typography color={"dark"} shade="c300" className="mb-0">
                  {rewardType === 3 ? selectedSite?.currencyCode : currencyCode}{" "}
                  {parseFloat(
                    rewardType === 3
                      ? selectedSite?.denomination_value
                      : recipient.total
                  ).toLocaleString()}
                </Typography>
              }
            </div>
            <div>
              {rewardType === 1 && (
                <Typography.HelperText
                  color={"dark"}
                  shade="c200"
                  className="mb-0"
                >
                  {parseFloat(recipient.total).toLocaleString()} points
                </Typography.HelperText>
              )}
              {rewardType === 2 && (
                <Typography.HelperText
                  color={"dark"}
                  shade="c200"
                  className="mb-0"
                >
                  {currencyCode}{" "}
                  {parseFloat(recipient.codeValue).toLocaleString()}x
                  {recipient.quantity}
                </Typography.HelperText>
              )}
            </div>
          </StyledDiv>
        </>
      )}
      <StyledDivGap
        className={`${
          isEditUserEnabled || !addMore ? "pointer-none" : ""
        } d-flex justify-content-end`}
      >
        <Tooltip tooltip="Edit Recipient" placement="bottom">
          <IconButton
            onClick={() => {
              if (isEditUserEnabled || addMore) return;
              handleEditUserData(recipient);
            }}
            iconName="Edit"
            color="dark"
            shade={isEditUserEnabled || addMore ? "c100" : "c200"}
            size={20}
          />
        </Tooltip>
        <Tooltip tooltip="Delete Recipient" placement="bottom">
          <IconButton
            onClick={() => {
              if (isEditUserEnabled || addMore) return;
              handleDeleteUserClick(recipient);
            }}
            iconName="Delete"
            color="dark"
            shade={isEditUserEnabled || addMore ? "c100" : "c200"}
            size={20}
          />
        </Tooltip>
      </StyledDivGap>
    </div>
  );
};

export default RecepientDataComponent;
